export enum VehicleConditionsType {
	REGULAR = "Regular",
	DAMAGED = "Avariado",
	NOT_AVAILABLE = "Não possui",
}
